<template>
  <div class="course-detail">
    <div class="online-course">
      <course-player ref="coursePlayer" v-if="courseCategoryData && courseCategoryData.length > 0"
        :current-video="currentVideo" class="course-player" :last-video-id="lastVideoId"
        :courseEvaluateList="courseEvaluateList" :video-list="courseCategoryData"></course-player>
      <van-image class="img-course-poster" fit="cover" v-else-if="courseData.coverMaterial"
        :src="courseData && courseData.coverMaterial.url">
      </van-image>
      <div class="flex-title flex-top">
        <div class="title-txt" :class="itemtxt === 0 ? 'cur' : ''" @click="handleClickItems(0)">
          课程介绍
          <img src="@/assets/images/home/underline@2x.png" v-if="itemtxt === 0" class="cur-icon" alt="">
        </div>
        <div class="title-txt" :class="itemtxt === 1 ? 'cur' : ''" @click="handleClickItems(1)">
          相似推荐
          <img src="@/assets/images/home/underline@2x.png" v-if="itemtxt === 1" class="cur-icon" alt="">
        </div>
      </div>
      <template v-if="itemtxt === 0">
        <div class="course-intro">
          <base-card class="expert-card">
            <div class="course-name">{{ courseData && courseData.name }}</div>
            <div class="item-txt">播放量：{{ courseData.playNum ? courseData.playNum : 0 }}</div>
            <template v-if="courseData.courseLecturers &&
              courseData.courseLecturers.length
              ">
              <div class="expert-content" v-for="(expert, eIdx) of courseData.courseLecturers" :key="expert + eIdx">
                <template v-if="eIdx === 0">
                  <div class="teacher-con">
                    <div class="teacher-info">
                      <van-image class="head-portrait" v-if="expert && expert.headPic" :src="expert && expert.headPic.url"
                        :loading-icon="iconUserHeadDefault" :error-icon="iconUserHeadDefault" round fit="cover" />
                      <div class="content">
                        <div class="name">{{ expert && expert.name }}</div>
                        <div class="title">{{ expert && expert.title }}</div>
                        <div class="hospital-name">
                          {{ expert && expert.hospitalName }}
                        </div>
                        <!--<div class="hospital">{{ expert.summary }}</div>-->
                      </div>
                    </div>
                    <div v-if="!teacherShow && expert.summaryText && expert.summaryText != ''
                      " class="watch-more" @click="teacherShow = !teacherShow">
                      <div class="txt">更多</div>
                      <img width="12" height="7" class="down-arrow" src="../../assets/images/course/icon-arrowDown.png" />
                    </div>
                  </div>
                  <div v-if="teacherShow && expert.summaryText && expert.summaryText != ''" class="summary">
                    <div class="conTxt" v-html="expert.summaryText" />
                    <div class="watch-more" @click="teacherShow = !teacherShow">
                      <div class="txt">收起</div>
                      <img width="12" height="7" class="down-arrow" src="../../assets/images/course/icon-arrowUp.png" />
                    </div>
                  </div>
                </template>
              </div>
            </template>
          </base-card>
        </div>
        <course-category :course-category-data="courseCategoryData" @switchTask="handleSwitchTask"></course-category>
        <course-introduction :introduction="courseIntroductionUrl"></course-introduction>
        <course-evaluate-list :evaluateList="courseEvaluateList"></course-evaluate-list>
      </template>
      <template v-else-if="itemtxt === 1">
        <div class="recomm-con">
          <div class="flex-title">
            <div class="title-txt" :class="itemRecomm === 2 ? 'cur' : ''" @click="handleClickRecommItems(2)">
              课程
              <img src="@/assets/images/home/underline@2x.png" v-if="itemRecomm === 2" class="cur-icon" alt="">
            </div>
            <div class="title-txt" :class="itemRecomm === 3 ? 'cur' : ''" @click="handleClickRecommItems(3)">
              病例
              <img src="@/assets/images/home/underline@2x.png" v-if="itemRecomm === 3" class="cur-icon" alt="">
            </div>
            <div class="title-txt" :class="itemRecomm === 1 ? 'cur' : ''" @click="handleClickRecommItems(1)">
              文献
              <img src="@/assets/images/home/underline@2x.png" v-if="itemRecomm === 1" class="cur-icon" alt="">
            </div>
          </div>
          <van-list v-model="loading" v-if="list.length > 0 && !isNone" :finished="finished" finished-text="我是有底线的" loading-text="正在加载..." @load="onLoad" class="cons-list">
            <div class="flex-con" v-for="(item, index) in list" :key="index" @click="handleJump(item)">
              <div class="left-con">
                <div class="txt1" :class="itemRecomm === 1 ? 'docu' : ''">{{ item.title }}</div>
                <div class="txt2" v-if="itemRecomm === 3">
                  <span class="span1">作者：{{ item.keynoteSpeaker }}</span>
                  <!-- <span class="span2">播放量:{{ item.readNum }}</span> -->
                </div>
                <div class="txt2" v-if="itemRecomm === 2">
                  <span class="span1">讲师：{{ item.keynoteSpeaker }}</span>
                  <!-- <span class="span2">播放量:{{item.readNum}}</span> -->
                </div>
                <div class="txt2" v-if="itemRecomm === 1">
                  <span class="span1"></span>
                  <!-- <span class="span2">播放量:{{item.readNum}}</span> -->
                </div>
              </div>
              <div class="right-con">
                <img :src="item.coverUrl" class="con-cover" alt="">
                <!-- <div class="tag-txt">选修</div> -->
              </div>
            </div>
          </van-list>
          <div class="search-none" v-else-if="list.length <= 0 && isNone">
            <img src="@/assets/images/home/empty_state_none@2x.png" class="none-img" alt="">
            <div class="none-txt">暂无内容</div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import BaseCard from '@/components/BaseCard.vue'
import CoursePlayer from './components/CoursePlayer.vue'
import CourseCategory from './components/CourseCategory.vue'
import CourseEvaluateList from './components/CourseEvaluateList.vue'
import CourseIntroduction from './components/CourseIntroduction.vue'
import iconUserHeadDefault from '@/assets/images/home/teacher-head.png'
import { getDatabaseCoursesDetail, similarRecommend } from '../../api/api'
import { hadnleUpdateVideo } from './components/common'
import { Toast } from 'vant'
import { getShareInfo } from '@/utils/wxShare'
import { setSha, traceClickURL } from '../../utils/util'
import {isScorm} from '../../api/scorm'
export default {
  name: 'course',
  components: {
    BaseCard,
    CoursePlayer,
    CourseCategory,
    CourseEvaluateList,
    CourseIntroduction
  },
  data () {
    return {
      // 导师信息展开合上
      teacherShow: false,
      // 课程数据
      courseData: {},
      courseCategoryData: [],
      // 默认头像
      iconUserHeadDefault,
      currentVideo: {},
      lastVideoId: '',
      courseEvaluateList: {},
      courseIntroductionUrl: '',
      itemtxt: 0,
      itemRecomm: 2,
      list: [],
      loading: false,
      finished: false,
      pageNum: 1,
      pageSize: 5,
      load: false,
      isNone: false
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    }
  },
  watch: {
    '$route' (newval, oldval) {
      this.init()
      this.itemtxt = 0
    }
  },
  mounted () {
    this.init()
    this.itemtxt = 0
  },
  methods: {
    handleClickItems (index) {
      this.itemtxt = index
      if (index === 1) {
        this.pageNum = 1
        this.finished = false
        this.list = []
        this.onLoad()
      }
    },
    handleClickRecommItems (index) {
      this.itemRecomm = index
      this.pageNum = 1
      this.finished = false
      this.list = []
      this.onLoad()
    },
    init (boolEva) {
      getDatabaseCoursesDetail({
        courseId: this.$route.query.courseId
      }).then(res => {
        if (boolEva) {
          this.courseEvaluateList = res.data.courseFeedbacks && res.data.courseFeedbacks.length > 0 ? res.data.courseFeedbacks[0] : {}
          return
        }
        this.courseData = res.data
        window.sessionStorage.setItem('serviceId', this.courseData.id)
        let entrance = (this.$route.query.entrance) ? this.$route.query.entrance : window.sessionStorage.getItem('entrance')
        window.sessionStorage.setItem('entrance', entrance)
        window.sessionStorage.setItem('traceTitle', '课程详情-' + this.courseData.name)
        let desc = ''
        if (this.courseData.courseLecturers.length > 0) {
          desc = `${this.courseData.courseLecturers[0].name} ${this.courseData.courseLecturers[0].title} ${this.courseData.courseLecturers[0].hospitalName}`
        }
        getShareInfo({
          title: this.courseData.name,
          titleTimeLine: this.courseData.name,
          desc: desc,
          link: window.location.href.indexOf('entrance') > -1 ? window.location.href : window.location.href + '&entrance=20',
          linkTimeLine: window.location.href.indexOf('entrance') > -1 ? window.location.href : window.location.href + '&entrance=21',
          images: this.courseData.coverMaterial.url,
        })
        if (window.location.href.includes('entrance')) {
          window.sessionStorage.setItem('moduleName', '课程')
        }
        this.courseCategoryData = res.data.courseChapters[0].courseSections.map(item => {
          // 视频的poster默认为课程的图片
          item.poster = res.data.coverMaterial ? res.data.coverMaterial.url : ''
          // 是否可以倍速播放 1可以，2不可以
          item.videoSpeedPlayback = res.data.videoSpeedPlayback
          // 谁否可以拖拽 1可以，2不可以
          item.dragFlag = res.data.dragFlag
          // watchPassPercent 后台传回来的视频观看到百分之几的时候等于完成
          item.watchPassPercent = res.data.watchPassPercent
          if (this.$route.query.sectionId && this.$route.query.sectionId === item.id) {
            item.learningStatus = '2'
            this.currentVideo = item
            this.handleSwitchTask(this.currentVideo)
          } else if ((item.learningStatus === '2' || item.learningStatus === '3' || !item.learningStatus) && Object.keys(this.currentVideo) && Object.keys(this.currentVideo).length <= 0) {
            item.learningStatus = '2'
            this.currentVideo = item
            this.handleSwitchTask(this.currentVideo)
          }
          return item
        })
        this.lastVideoId = this.courseCategoryData[this.courseCategoryData.length - 1].id
        this.courseEvaluateList = res.data.courseFeedbacks && res.data.courseFeedbacks.length > 0 ? res.data.courseFeedbacks[0] : {}
        this.courseIntroductionUrl = res.data.posterData && res.data.posterData.url ? res.data.posterData.url : ''
        if (Object.keys(this.currentVideo) && Object.keys(this.currentVideo).length <= 0) {
          this.currentVideo = this.courseCategoryData[0]
        }
      }).catch(() => {
        Toast('当前id没有内容，请联系管理员添加')
      })
    },
    handleSwitchTask (task) {
      this.currentVideo = task
      hadnleUpdateVideo(this.currentVideo)
    },

    onLoad () {
      if (this.load) {
        return
      }
      this.load = true
      let params = {
        type: this.itemRecomm,
        contentId: this.$route.query.courseId,
        openId: this.userInfo.iepOpenId,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        sectionId: this.currentVideo.id
      }
      similarRecommend(params).then(res => {
        this.load = false
        if (res.data.list.length < this.pageSize) {
          this.finished = true
        }
        this.list = this.list.concat(res.data.list)
        // 加载状态结束
        this.loading = false
        if (this.list.length <= 0) {
          this.isNone = true
        } else {
          this.isNone = false
        }
        this.pageNum++
      })
    },
    async handleJump (item) {
      // this.$refs.coursePlayer.$refs.video.acPlayerToolInit.dispose()
      let trackParams = `&entrance=4&businessChannel=4`
      if (item.type === 1) {
        this.$router.push({
          path: '/articleDetails',
          query: {
            id: item.baseId,
            entrance: '4',
            channel: '4'
          }
        })
        // setTimeout(() => { traceClickURL() })
        // let openid = `&unionid=${this.userInfo.unionId}&openid=${this.userInfo.iepOpenId}${setSha(`xxbiep${this.userInfo.iepOpenId}`)}`
        // let iepTxt = `&nickname=123&avatar=123&subscribe=1`
        // window.location.href = `${process.env.iepUrl}/mobile/home/article-detail?index=0&id=${item.baseId}${openid}${iepTxt}${trackParams}`
      } else if (item.type === 3) {
        setTimeout(() => { traceClickURL() })
        let openidBindli = `&unionid=${this.userInfo.unionId}&openid=${this.userInfo.iepOpenId}${setSha(`xxbiep${this.userInfo.iepOpenId}`)}`
        window.location.href = `${process.env.bingliUrl}/wap/index.html#/casedetails?id=${item.baseId}${openidBindli}${trackParams}`
      } else if (item.type === 2) {
        window.sessionStorage.setItem('entrance', '4')
        const query = {
          courseId: item.baseId,
          sectionId: item.sectionId,
          entrance: '4',
          channel: '4'
        }
        const isscorm = await isScorm(item.baseId)
        let path = '/courserDetails'
        if (isscorm.data) {
          path = '/scormCourseDetail'
        }
        this.$router.push({path, query}).then(() => {
          window.location.reload()
        })
      }
    },
  }
}
</script>

<style lang="less" scoped>
.course-detail {
  padding-bottom: 20px;
  min-height: 100vh;
  background-color: rgb(247, 248, 250);

  .online-course {
    padding-top: 200px;

    /deep/ .van-tabs__line {
      width: 24px;
      height: 2px;
      background: #EB1700;
    }

    .course-player,
    .img-course-poster {
      top: 0;
      left: 0;
      position: fixed;
      z-index: 100;
      width: 375px;
      height: 200px;

      .course-play-icon {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 40px;
        height: 40px;
      }
    }

    .course-intro {
      padding: 56px 12px 0;

      .course-name {
        font-size: 15px;
        font-weight: bold;
        color: #1f333f;
      }

      .item-txt {
        font-size: 12px;
        color: #B8B8B8;
        font-weight: 500;
        line-height: 17px;
        margin-top: 3px;
      }

      .expert-card {
        .expert-content {
          padding: 15px 0 0;

          .teacher-con {
            display: flex;
            align-items: flex-end;
          }

          .teacher-info {
            display: flex;
            align-items: center;
            flex: 1;

            .head-portrait {
              flex-shrink: 0;
              width: 55px;
              height: 55px;
              border-radius: 50%;

              /deep/ .van-icon__image {
                width: 100%;
                height: 100%;
              }
            }

            .content {
              display: flex;
              flex-direction: column;
              justify-content: center;
              margin: 0 12px;

              .name {
                font-size: 14px;
                font-weight: bold;
                color: #1f333f;
                max-width: 200px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }

              .title {
                font-size: 12px;
                color: #6d6d6d;
                margin: 2px 0;
                max-width: 200px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }

              .hospital-name {
                font-size: 12px;
                color: #6d6d6d;
                max-width: 200px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }

              .hospital {
                margin-top: 10px;
                margin-left: 2px;
                font-size: 12px;
                font-weight: 500;
                color: #a1adb9;
              }
            }
          }

          .summary {
            margin-top: 17px;
            padding-top: 20px;
            padding-bottom: 7px;
            border-top: 1px solid #eeeeee;

            .conTxt {
              font-size: 13px;
              font-weight: 500;
              color: #666666;
              padding-bottom: 20px;
            }

            .watch-more {
              justify-content: flex-end;
            }
          }

          .watch-more {
            display: flex;
            align-items: center;
            padding-right: 6px;
            width: 60px;

            .txt {
              font-size: 12px;
              font-weight: 500;
              color: #1f333f;
              margin-right: 6px;
            }

            img {
              width: 12px;
              height: 7px;
            }
          }
        }
      }
    }
  }

  .flex-title {
    display: flex;
    align-items: center;
    background-color: #fff;
    position: fixed;
    width: 100%;
    top: 200px;
    left: 0;
    z-index: 99;
    &.flex-top {
      .title-txt {
        max-width: 30%;
      }
    }

    .title-txt {
      flex: 1;
      text-align: center;
      line-height: 40px;
      font-size: 15px;
      color: #6A7481;

      .cur-icon {
        width: 23px;
        height: 10px;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
      }

      &.cur {
        color: #EB1700;
        position: relative;
        font-weight: 500;
      }
    }
  }

  .recomm-con {
    margin: 56px 12px 0;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.08);
    background-color: #fff;
    padding-bottom: 1px;
    box-sizing: border-box;
    border-radius: 12px;
    position: relative;
    /deep/.van-list__finished-text, /deep/.van-list__loading {
      position: absolute;
      bottom: -60px;
      text-align: center;
      width: 100%;
    }

    .flex-title {
      position: static;
      padding: 0 30px;
      box-sizing: border-box;
      margin-bottom: 10px;
      border-radius: 12px 12px 0 0;

      .title-txt {
        color: #5B5F6A;

        &.cur {
          font-weight: 500;
          color: #000000;
        }
      }
    }

    .flex-con {
      display: flex;
      justify-content: space-between;
      padding: 0 12px;
      box-sizing: border-box;
      margin-bottom: 25px;
      align-items: center;

      .right-con {
        width: 110px;
        height: 60px;
        position: relative;
        border-radius: 5px;
        overflow: hidden;

        .con-cover {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .tag-txt {
          position: absolute;
          width: 30px;
          height: 16px;
          font-size: 10px;
          background-color: #6A7481;
          border-radius: 5px;
          left: 0;
          top: 0;
          text-align: center;
          line-height: 16px;
          color: #fff;
          font-size: 10px;
        }
      }

      .left-con {
        .txt1 {
          font-size: 14px;
          color: #000000;
          font-weight: 500;
          line-height: 20px;
          margin-bottom: 8px;
          width: 200px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          &.docu {
            white-space: inherit;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }

        .txt2 {
          display: flex;
          justify-content: space-between;
          align-items: center;
          color: #B1B1B1;
          font-size: 12px;
        }
      }
    }
    .search-none {
      padding-bottom: 40px;
      box-sizing: border-box;
      .none-img {
        width: 185px;
        margin-left: 50%;
        transform: translateX(-50%);
        margin-top: 50px;
      }

      .none-txt {
        font-size: 12px;
        color: #949BA5;
        text-align: center;
        margin-top: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/course/courserDetailsXwzy.vue